import { Middleware } from '@reduxjs/toolkit';

export function errorMiddleware(): Middleware {
  return store => next => action => {
    try {
      return next(action);
    } catch (err: any) {
      throw err;
    }
  };
}
